import { render, staticRenderFns } from "./AnktAnketPaylas.vue?vue&type=template&id=6b2b1082&"
import script from "./AnktAnketPaylas.vue?vue&type=script&lang=js&"
export * from "./AnktAnketPaylas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports